{
  "_comment": "Hand-maintained figures the public stats feed does not carry. Refresh them together, and say in the commit message when they were measured. See figures.ts for what each one means.",
  "overshootPercent": 125,
  "shareDrivenPercent": 20,
  "smallestSuccessEur": 15,
  "ownerTypes": [
    { "label": "Particuliers (ou auto-entrepreneurs)", "percent": 54 },
    { "label": "Entreprises", "percent": 28 },
    { "label": "Associations", "percent": 18 }
  ]
}
